<template lang="pug">
b-tag.is-rounded(v-if="value", :type="attrType")
  b-icon(:icon="attrIcon", size="mdi-24px")
</template>

<script>
export default {
  name: 'platform-priority-icon',

  props: {
    value: Number,
  },
  computed: {
    attrIcon() {
      // return `home-floor-${this.value}`;
      // return `numeric-${this.value}-circle-outline`;
      // return `numeric-${this.value}-circle`;
      return `numeric-${this.value}`;
    },
    attrType() {
      return ['', 'is-danger', 'is-warning', 'is-grey'][this.value];
    },
  },
};
</script>
